module.exports = __webpack_public_path__ + "img/shutterstock_130027559.4b1b45be.jpg";